import {
  heroAdjustmentsHorizontal,
  heroUsers,
  heroCalendarDays,
  heroPencilSquare,
  heroChartPie,
  heroArrowSmallLeft,
  heroMagnifyingGlass,
  heroArrowPath,
  heroChevronLeft,
  heroChevronDoubleLeft,
  heroChevronRight,
  heroChevronDoubleRight,
  heroPencil,
  heroTrash,
  heroEye,
  heroChevronUpDown,
  heroPlus,
  heroXMark,
  heroBars3,
  heroDocument,
  heroHome,
  heroArrowLeftEndOnRectangle,
  heroExclamationTriangle,
  heroArrowRightStartOnRectangle,
} from '@ng-icons/heroicons/outline';
import { heroArrowLeftCircleSolid } from '@ng-icons/heroicons/solid';

export default {
  heroAdjustmentsHorizontal,
  heroUsers,
  heroCalendarDays,
  heroPencilSquare,
  heroChartPie,
  heroArrowSmallLeft,
  heroArrowLeftCircleSolid,
  heroMagnifyingGlass,
  heroArrowPath,
  heroChevronLeft,
  heroChevronDoubleLeft,
  heroChevronRight,
  heroChevronDoubleRight,
  heroPencil,
  heroTrash,
  heroEye,
  heroChevronUpDown,
  heroPlus,
  heroXMark,
  heroBars3,
  heroDocument,
  heroHome,
  heroArrowLeftEndOnRectangle,
  heroArrowRightStartOnRectangle,
  heroExclamationTriangle,
};
